<template>
  <div id="app" class="mb-4">
    <ThemeHandler class="mt-2 ml-2" v-if="!isMobile && !isPrintPage"></ThemeHandler>
    <div class="container mb-4 mt-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <!-- Logo as the Home Link -->
        <h1 class="logo">
          <router-link to="/">
            <img alt="Logo" src="./assets/logo.png" width="250" />
          </router-link>
        </h1>
        <!-- Navigation links -->
        <b-nav tabs align="right">
          <b-nav-item to="/">{{ $t('app.featured') }}</b-nav-item>
          <b-nav-item to="/all-cocktails">{{ $t('All Cocktails') }}</b-nav-item>
          <b-nav-item to="/search">{{ $t('Search Drinks') }}</b-nav-item>
          <b-nav-item to="/favorites">{{ $t('Saved Cocktails') }}</b-nav-item>
        </b-nav>
      </div>

      <HeroSection />
    </div>

    <router-view />
    <CTABanner />
    <footer class="container mt-4 text-center">
      <hr />
    </footer>
  </div>
</template>

<script>
import HeroSection from '@/components/HeroSection.vue'; 
import ThemeHandler from '@/components/ThemeHandler.vue';
import CTABanner from '@/components/CTABanner.vue';

export default {
  name: 'App',
  components: {
    HeroSection,
    ThemeHandler,
    CTABanner,
  },
  metaInfo() {
    return {
      title: 'Bartend Long Island',
      htmlAttrs: {
        lang: 'en',
      },
      meta: [
        {
          name: 'description',
          content: 'Bartend Long Island Drink Recipes',
          vmid: 'description',
        },
      ],
    };
  },
};
</script>

<style scoped>
.d-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 768px) {
  .d-flex {
    flex-direction: column;
    text-align: center;
  }

  .logo {
    margin-bottom: 20px;
  }

  .b-nav {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
